module.exports = __webpack_public_path__ + "static/media/MEMBRESIA golden.1a800877.png";